import React from 'react'
import { MDBCard, MDBCardBody } from 'mdb-react-ui-kit'
import classes from './StepCard.module.css'

export default function StepCard({ step, image, text }) {
  return (
    <MDBCard
      className={`position-relative mx-auto my-5 mx-md-0 my-md-0 text-center p-md-2 p-lg-3 shadow-3 ${classes.stepCard}`}
    >
      {/* Step Number */}
      <img
        className={`${classes.imageNum} position-absolute  translate-middle bg-dark text-white d-flex align-items-center justify-content-center`}
        src={step}
        alt="Step Number"
      >
      </img>

      {/* Image */}
      <div
      className={classes.imgDiv}
      >
        <img
          src={image}
          alt="Verification Step"
          className={classes.image}
        />
      </div>

      {/* Text */}
      <MDBCardBody className="p-1">
        <p className="font-pays my-0 my-md-2">{text}</p>
      </MDBCardBody>
    </MDBCard>
  )
}
